import React, { SVGProps } from "react";

const LanguageIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_864_12012)">
        <path
          d="M12.6276 13.5495H7.60676L4.46875 16.6875V13.5495H2.58594V2.25262H12.6276V13.5495Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3726 17.9428H16.3934L19.5314 21.0808V17.9428H21.4142V6.64593H12.6278V13.5496H11.3726V17.9428Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.09644 6.01831H10.1173"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.48943 6.01824V6.01855C9.10346 8.33504 7.46826 10.2483 5.24057 10.9911C5.1483 11.0218 5.09619 11.0391 5.09619 11.0391"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.35156 7.90102C6.35156 7.90102 6.53887 8.18629 6.78707 8.56441C7.56977 9.75719 8.7493 10.6339 10.1171 11.0391"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.60693 6.01831V4.76308"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5103 14.8047C14.5103 14.8047 15.2791 11.7294 15.6133 10.3923C15.7027 10.0346 16.024 9.78387 16.3928 9.78387H16.3934C16.7621 9.78387 17.0834 10.0346 17.1729 10.3923C17.5071 11.7294 18.2759 14.8047 18.2759 14.8047"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.824 13.5496H17.962"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_864_12012">
          <rect width="20" height="20" fill="white" transform="translate(2 1.66675)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LanguageIcon;
